function getVisitorId() {
    function getCookie(name) {
      const cookieArr = document.cookie.split(";");
      for(let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if(name == cookiePair[0].trim()) {
          return decodeURIComponent(cookiePair[1]);
        }
      }
      return null;
    }
  
    let visitorId = getCookie("fdv_visitor_id");
    return visitorId;
  };

function setCookie(name, value, m) {
  let expires = "";
  if (m) {
    let date = new Date();
    date.setTime(date.getTime() + (m  * 60 * 1000)); //minutos
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};


function closePopup() {
    // Close the popup
    const now = new Date();
    const timestamp = now.getTime();
    const currentUrl = window.location.href;
    const referralUrl = document.referrer;
    const event_name = 'fdv-modal-bola-de-cristal-close';
    const event_data = {timestamp: timestamp, path: currentUrl, referral: referralUrl};
    Shopify.analytics.publish(event_name, event_data);
    document.getElementById('popup-container-fdv').style.opacity = 0;
    document.getElementById('overlay-fdv-modal').style.opacity = 0;

    setTimeout(() => {
        document.getElementById('popup-container-fdv').style.display = 'none';
        document.getElementById('overlay-fdv-modal').style.display = 'none';
    }, 1000); // Wait for 1 second before hiding to match transition duration
};

// Function to show the popup and the overlay
function showPopup() {
    const cartDrawerElement = document.querySelector('#CartDrawer');
    if (targetElement.classList.contains('drawer--is-open')) {
      resetIdleTimer();
      return;
    }
    clearTimeout(timeoutId);
    window.removeEventListener('scroll', scrollHandler);
    window.removeEventListener('mousemove', resetIdleTimer);
    window.removeEventListener('keypress', resetIdleTimer);
    window.removeEventListener('touchmove', resetIdleTimer);
    document.getElementById('popup-container-fdv').style.display = 'flex';
    document.getElementById('overlay-fdv-modal').style.display = 'block';

    // Triggering reflow to apply initial styles before transitioning opacity
    void document.getElementById('popup-container-fdv').offsetWidth; // This triggers a reflow, making sure the transition is applied

    document.getElementById('popup-container-fdv').style.opacity = 1;
    document.getElementById('overlay-fdv-modal').style.opacity = 1;

    startAnimation();
    
    // Get the current date and time
    const now = new Date();

    // Get the timestamp in milliseconds
    const timestamp = now.getTime();
    const currentUrl = window.location.href;
    const referralUrl = document.referrer;
    const event_name = 'fdv-modal-bola-de-cristal-show';
    const event_data = {timestamp: timestamp, path: currentUrl, referral: referralUrl};
    Shopify.analytics.publish(event_name, event_data);
    setCookie('tarot_cookie_v14',true,60*24*4);
}

function onIdle() {
    add_cart_counter = getCookie('add_cart_counter');
    //if (add_cart_counter > 1) {
      showPopup();
    //}
  }

// Reset the idle timer
function resetIdleTimer() {
    // Clear the existing timeout
    clearTimeout(timeoutId);

    // Set a new timeout
    timeoutId = setTimeout(onIdle, idleTimeout);
}


// Definir el callback en una función con nombre
function scrollHandler() {
    const st = window.scrollY || document.documentElement.scrollTop;
    const scrollDistance = Math.abs(st - lastScrollTop);

    if (st > lastScrollTop && scrollDistance > scrollThreshold) {
        // Desplazamiento significativo hacia abajo
        scrollDownDetected = true;
    } else if (st < lastScrollTop && scrollDistance > scrollThreshold) {
        // Desplazamiento significativo hacia arriba
        if (scrollDownDetected) {
          add_cart_counter = getCookie('add_cart_counter');
          //if (add_cart_counter > 0) {
            showPopup();
          //}
            // Remover el event listener una vez mostrado el popup
        }
    }

    lastScrollTop = st <= 0 ? 0 : st; // Asegurarse de no tener valores negativos
}


let lastScrollTop = 0;
let scrollDownDetected = false;
const scrollThreshold = 32;
var add_cart_counter = getCookie('add_cart_counter');



// Define the idle timeout duration
const idleTimeout = 6000; // 3000 ms = 3 seconds

let timeoutId;


let tarot_cookie = getCookie('tarot_cookie_v14');
//let exclude_cookie = getCookie('exclude_exit_popup')


//if (!exclude_cookie ) {
  if (!tarot_cookie) {
  // Initialize the timer for the first time
    resetIdleTimer();
    window.addEventListener('scroll', scrollHandler, false);
    // Listen for mouse movements, keypresses, and touch movements
    window.addEventListener('mousemove', resetIdleTimer);
    window.addEventListener('keypress', resetIdleTimer);
    window.addEventListener('touchmove', resetIdleTimer);
  }
//}


const container = document.getElementById('text-container');
const witchImage = document.getElementById('witch-image');
const ballImage = document.getElementById('ball-image');
const fortuneButton = document.getElementById('fortune-button');
const emailButton = document.getElementById('email-button');
const discountButton = document.getElementById('discount-button');
const comprarButton = document.getElementById('comprar-button');
const textPromotionTitle = document.getElementById('text-promotion-title');


// Function to animate text sequentially
async function animateTexts(elements, textsInnerHTML) {
    for (let index = 0; index < elements.length; index++) {
        await animateText(elements[index], textsInnerHTML[index]);
    }
}

// Function to animate text for an element
async function animateText(element, content, speed = 20) {
    return new Promise(resolve => {
        let currentIndex = 0;

        function addNextLetter() {
            if (currentIndex < content.length) {
                element.textContent += content.charAt(currentIndex);
                currentIndex++;
                setTimeout(addNextLetter, speed); // Adjust speed here (default: 30ms)
            } else {
                resolve();
            }
        }

        addNextLetter();
    });
}

// Function to toggle button visibility
function toggleButtonVisibility(buttonToShowID, buttonToHideID) {
    const buttonToHide = document.getElementById(buttonToShowID);
    const buttonToShow = document.getElementById(buttonToHideID);
    buttonToHide.classList.add('modal-fdv-hidden');
    buttonToShow.classList.remove('modal-fdv-hidden');
}


// Function to update container content
function updateContainerContent(htmlContent, animatedTexts) {
    container.innerHTML = htmlContent;
    animateTexts(document.querySelectorAll('.texto-animado'),animatedTexts);
}



// Function to update text promotion title
function updateTextPromotionTitle(titleHtmlContent) {
    const textPromotionTitle = document.getElementById('text-promotion-title');
    textPromotionTitle.innerHTML = titleHtmlContent;
    textPromotionTitle.classList.toggle('modal-fdv-show-overlay');
}

async function fetchPromotion(email, promotionCategory) {
    const url = 'https://discounts.flordevenus.com.mx/get_promotion'; // Replace with your correct URL
    const requestBody = {
        email: email,
        promotion_category: promotionCategory
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`); // Corrected error handling
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching promotion:', error);
        return { error: error.message };
    }
}

async function get_promotion(email, promotionCategory) {
    try {
        const data = await fetchPromotion(email, promotionCategory);
        const promotionTitle = data.promotion_title;
        const htmlContentPromotionTitle = `
            <p class="texto-color-light-fdv modal-fdv-text-promotion-title im-fell-english-regular">${promotionTitle}</p>
        `;
        return {
            promotionTitle: htmlContentPromotionTitle,
            promotionText: data.promotion_text,
            promotionCode: data.promotion_code
        };
    } catch (error) {
        console.error('Error:', error);
        return { 
            promotionTitle: '',
            promotionText: '',
            promotionCode: ''
        }; // Handle error scenario
    }
}

// Initial HTML content
const initialHtmlContent = `
    <p class="texto-color-dark-fdv im-fell-english-regular modal-texto-titulo">DIOSA MARINA ORÁCULO DEL OCÉANO:</p>
    <p class="texto-color-dark-fdv im-fell-english-regular texto-animado" id="animated-text-1"></p>
`;

// Initial text animation content
const initialTextsInnerHTML = ['¡Hola, alma curiosa! Soy la Diosa Marina, protectora de los Secretos del Mar. Permíteme revelar tu fortuna con una lectura de tarot y, en agradecimiento, recibirás un cupón de descuento para nuestra tienda.🕯️'];

function startAnimation() {
  updateContainerContent(initialHtmlContent, initialTextsInnerHTML);
}


// Event listener for close button
document.getElementById('close-button').addEventListener('click', function() {
    closePopup();
});

// Event listener for fortune button
fortuneButton.addEventListener('click', async function() {
    const oldImg = document.getElementById('witch-image');
    const newImg = document.getElementById('tarot-image');
  
    // Fade out old image
    oldImg.classList.add('fade-to-black');
    setTimeout(() => {
      oldImg.classList.add('modal-fdv-hidden');
      oldImg.classList.remove('fade-to-black'); // Remove the fade-to-black class
    }, 500);
  
    // Fade in new image and show it after fade-in
    setTimeout(() => {
      newImg.classList.remove('modal-fdv-hidden'); // Ensure new image is visible
      newImg.classList.add('fade-in-image');
    }, 500); // Start after the old image has faded out
  
    // Remove fade-in class from new image after animation completes
    setTimeout(() => {
      newImg.classList.remove('fade-in-image');
    }, 1000); // Wait 500ms more for the fade-in effect to complete (total 1000ms)

    // Example content update (ensure this part works separately)
    const htmlContent = `
    <p class="texto-color-dark-fdv im-fell-english-regular modal-texto-titulo">DIOSA MARINA ORÁCULO DEL OCÉANO:</p>
    <p class="texto-color-dark-fdv im-fell-english-regular texto-animado" id="animated-text-1"></p>
    <div class="modal-fdv-email-input-div">
        <input type="text" id="fdv-modal-email-input" rows="1" class="texto-color-dark-fdv im-fell-english-regular modal-fdv-email-input" placeholder="Email..."></input>
    </div>`;
    
    // Toggle button visibility (make sure this function works)
    toggleButtonVisibility('fortune-button', 'email-button');
    
    // Update container content (check if this function works as expected)
    updateContainerContent(htmlContent, ['Por favor, regístrate en nuestro Newsletter para que pueda leerte el tarot y activar tu cupón de descuento.']);
});

async function handleEmailButtonClick() {
    const emailInput = document.getElementById('fdv-modal-email-input');
    let email_value = emailInput.value;
    
    // Regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email is valid
    if (!emailRegex.test(email_value)) {
        alert('Añade un correo valido.');
        return;
    }
    email_value = email_value.toLowerCase()
    emailButton.removeEventListener('click', handleEmailButtonClick);
    window.email_value = email_value;
    const now = new Date();
    const timestamp = now.getTime();
    const currentUrl = window.location.href;
    const referralUrl = document.referrer;
    const event_name = 'fdv-modal-bola-de-cristal-email-submit';
    updateContainerContent(`
        <p class="texto-color-dark-fdv im-fell-english-regular modal-texto-titulo">DIOSA MARINA ORÁCULO DEL OCÉANO:</p>
        <p class="texto-color-dark-fdv im-fell-english-regular texto-animado" id="animated-text-1"></p>
    `, ['🕯️Veamos que carta sale.....🕯️']);
    

    // Call the get_promotion function with the valid email
    window.promotionData = await get_promotion(email_value, 'tarot_diosa_default');
    const event_data = {timestamp: timestamp, path: currentUrl, referral: referralUrl, email: email_value};
    Shopify.analytics.publish(event_name, event_data);
    const promotionWon = window.promotionData.promotionCode;
    const promotionsDict = {
      soledad10: 'hermitano-image',
      estrella15: 'estrella-image',
      torre20: 'torre-image',
      emperatriz25: 'emperatriz-image',
      sacerdotisa10: 'sacerdotisa-image',
      sabiduria15: 'hierofante-image',
    };

    const imgId = promotionsDict[promotionWon.toLowerCase()];
    const oldImg = document.getElementById('tarot-image');
    const newImg = document.getElementById(imgId);
  
    // Fade out old image
    oldImg.classList.add('fade-to-black');
    setTimeout(() => {
      oldImg.classList.add('modal-fdv-hidden');
      oldImg.classList.remove('fade-to-black'); // Remove the fade-to-black class
    }, 500);
  
    // Fade in new image and show it after fade-in
    setTimeout(() => {
      newImg.classList.remove('modal-fdv-hidden'); // Ensure new image is visible
      newImg.classList.add('fade-in-image');
    }, 500); // Start after the old image has faded out
  
    // Remove fade-in class from new image after animation completes
    setTimeout(() => {
      newImg.classList.remove('fade-in-image');
    }, 500); // Wait 500ms more for the fade-in effect to complete (total 1000ms)

  

    // Update text promotion title
    //updateTextPromotionTitle(window.promotionData.promotionTitle);

    // Toggle button visibility
    toggleButtonVisibility('email-button', 'discount-button');
    setTimeout(() => {
    // Update container content
    updateContainerContent(`
        <p class="texto-color-dark-fdv im-fell-english-regular modal-texto-titulo">DIOSA MARINA ORÁCULO DEL OCÉANO:</p>
        <p class="texto-color-dark-fdv im-fell-english-regular texto-animado" id="animated-text-1"></p>
    `, [window.promotionData.promotionText]);
    }, 500);
};

// Event listener for email button
emailButton.addEventListener('click', handleEmailButtonClick);


discountButton.addEventListener('click', async function() {
  toggleButtonVisibility('discount-button', 'comprar-button');
  var compra_txt = '¡Tu cupón se aplicará automáticamente en tu carrito comprando con tu correo '+window.email_value+'! VALIDO SOLO HOY🕯️🕯️🕯️';
  updateContainerContent(`
      <p class="texto-color-dark-fdv im-fell-english-regular modal-texto-titulo">DIOSA MARINA ORÁCULO DEL OCÉANO:</p>
      <p class="texto-color-dark-fdv im-fell-english-regular texto-animado" id="animated-text-1"></p>
  `, [compra_txt]);

});

comprarButton.addEventListener('click', async function() {
  closePopup();
  //const currentUrl = window.location.href;
  //const baseUrl = currentUrl.split('?')[0];
  const baseUrl = 'https://flordevenus.com.mx/'
  const newString = "discount/" + window.promotionData.promotionCode;
  const lastChar = baseUrl.slice(-1);
  let newUrl;
  if (lastChar != '/') {
    newUrl = baseUrl + '/' + newString;
  } else {
    newUrl = baseUrl + newString;
  }
  window.location.href = newUrl;
});

